import React, { Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { API_GMAIL_AUTH, API_GMAIL, postAPI_Create_GmailIntegration } from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { changeCurrentIntegrationTab } from '../../../../redux/settings/actions';

class Index extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    console.log(state);
    if (code && state) {
      AxiosAPI({
        method: 'get',
        url: `${API_GMAIL}/${state.split('_')[0]}?group_id=${getGroupID()}`,
      })
        .then((json) => {
          console.log(json.data);
          let email = state.split('_')[1];
          let integration = json.data;
          AxiosAPI({
            method: 'post',
            url: `${API_GMAIL_AUTH}/setup`,
            data: { code: code, redirectUri: `https://app.devtest.bookmebob.com/${process.env.REACT_APP_GOOGLE_REDIRECT_URL}` },
          }).then((res) => {
            console.log(res.data, 30);
            let channelDetails = integration.channelDetails || {};
            console.log(channelDetails?.emails, integration, 'channelDetails.emails');
            if (channelDetails.emails) {
              let obj = channelDetails.emails.find((o) => o.email === email);
              console.log(obj);
              if (obj) {
                channelDetails.emails.find((o) => o.email === email).refreshToken = res.data.tokenResp.refresh_token;
                integration.channelDetails = channelDetails;
              } else {
                channelDetails?.emails.push({ email: email, refreshToken: res.data.tokenResp.refresh_token, enableWebhooks: true });
                integration.channelDetails = channelDetails;
              }
            }

            AxiosAPI({
              method: 'post',
              url: `${postAPI_Create_GmailIntegration}`,
              data: {
                'groupId': getGroupID(),
                'gmailUserId': email,
                'integrationId': integration.id,
                'creator': 'Gmail',
                'propertyId': this.props.propertyId,
              },
            })
              .catch((err) => console.error(err))
              .then(() => {
                console.log(`/app/pages/gmail-integrationdetail/${state.split('_')[0]}`, 52)
                //window.location.href = `/app/pages/gmail-integrationdetail/${state.split('_')[0]}`;
              });

            AxiosAPI({
              method: 'put',
              url: `${API_GMAIL}/${integration.id}?group_id=${getGroupID()}`,
              data: integration,
            })
              .catch((err) => console.error(err))
              .then(() => {
                console.log(`/app/pages/gmail-integrationdetail/${state.split('_')[0]}`, 52)
                changeCurrentIntegrationTab('Subscriptions');
                window.location.href = `/app/pages/gmail-integrationdetail/${state.split('_')[0]}`;
              });
          }).catch((err) => window.location.href = `/app/pages/gmail-integrationdetail/${state.split('_')[0]}`);
        }).catch((err) => window.location.href = `/app/pages/gmail-integrationdetail/${state.split('_')[0]}`);
    }

  }

  render() {
    return <Fragment></Fragment>;
  }
}
const mapStateToProps = ({ settings, service }) => {
  const { propertyId, tiktokId } = settings;
  const { featuresUrl } = service;
  return {
    propertyId,
    tiktokId,
    featuresUrl
  };
};

export default injectIntl(connect(mapStateToProps, {changeCurrentIntegrationTab})(Index));

